import { useTranslation } from "react-i18next"
import { useAdminAreal } from "@/hooks/useAdminAreal"
import { QrCodeSection } from "./sections/QrCodeSection"
import { EmailConfigSection } from "./sections/EmailConfigSection"
import { EmailTemplatesSection } from "./sections/EmailTemplatesSection"
import { TeamSection } from "./sections/TeamSection"
import { LogoSection } from "./sections/LogoSection"
import { BasicInfoSection } from "./sections/BasicInfoSection"
import { LocationSection } from "./sections/LocationSection"
import { ContactSection } from "./sections/ContactSection"
import { FinancialSection } from "./sections/FinancialSection"
import { LocalizedTextSection } from "./sections/LocalizedTextSection"
import { PhotoSection } from "./sections/PhotoSection"
import { TransferSection } from "./sections/TransferSection"
import { UbyportSection } from "./sections/UbyportSection"
import { BeskydCardSection } from "./sections/BeskydCardSection"
import { DangerZoneSection } from "./sections/DangerZoneSection"

export const AdminArealSettingsPage = () => {
    const { t } = useTranslation()
    const { data: areal, isLoading, dataUpdatedAt } = useAdminAreal()

    if (isLoading) {
        return <div className="text-slate-400 font-bold py-8 text-center">{t("common.loading")}</div>
    }

    if (!areal) {
        return <div className="text-red-500 font-bold py-8 text-center">{t("admin.settings.noAreal")}</div>
    }

    return (
        <div className="space-y-6">
            <div>
                <h1 className="text-3xl font-black tracking-tight text-slate-900">{t("admin.settings.title")}</h1>
                <p className="text-slate-500 font-bold mt-1">{areal.name}</p>
            </div>

            <BasicInfoSection areal={areal} />
            <LogoSection areal={areal} />
            <QrCodeSection areal={areal} />
            <LocationSection areal={areal} />
            <ContactSection areal={areal} />
            <FinancialSection key={dataUpdatedAt} areal={areal} />

            <LocalizedTextSection
                arealId={areal.id}
                field="description"
                title={t("admin.settings.translationDescriptionLabel")}
            />

            <LocalizedTextSection
                arealId={areal.id}
                field="operatingRules"
                title={t("admin.settings.sectionRules")}
                placeholder={t("admin.settings.fieldRulesPlaceholder")}
            />

            <PhotoSection arealId={areal.id} />
            <TeamSection arealId={areal.id} />
            <EmailConfigSection arealId={areal.id} />
            <EmailTemplatesSection arealId={areal.id} />
            <TransferSection areal={areal} />
            <UbyportSection areal={areal} />
            <BeskydCardSection arealId={areal.id} />
            <DangerZoneSection areal={areal} />
        </div>
    )
}
